import { useState } from 'react';

const portfolioItems = [
  {
    id: 12,
    title: 'Junk Removal Job',
    category: 'Residential',
    image: 'https://storage.readdy-site.link/project_files/1b93c930-6d5b-4ea2-b19e-5b9f42b39a02/3a4816fc-bffc-431b-8bf7-ee5f163e7899_IMG_7523.jpeg?v=e2eafa3742a122b51346ff7b029a6e16',
    description: 'Professional junk removal and hauling service completed with care'
  },
  {
    id: 1,
    title: 'Residential Junk Removal',
    category: 'Residential',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/bd3b9b551260ade360170edf86ec8522.jpeg',
    description: 'Professional junk hauling service with our dump trailer'
  },
  {
    id: 2,
    title: 'Dump Site Drop-Off',
    category: 'Commercial',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/caeb50a974fd07d75fec4b18e5b4e166.jpeg',
    description: 'Full load disposal at the recycling facility'
  },
  {
    id: 3,
    title: 'Storage Unit Cleanout',
    category: 'Residential',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/ce77799342fe1ada416ee737e38b4576.jpeg',
    description: 'Complete storage unit junk removal and hauling'
  },
  {
    id: 4,
    title: 'Garage Cleanout',
    category: 'Residential',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/0f32e931ea78d42bc4c1785e3ba94e55.jpeg',
    description: 'Full garage cleanout with boxes and clutter removal'
  },
  {
    id: 5,
    title: 'Trailer Unloading',
    category: 'Commercial',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/83eeb982b6307643242d8ca8dfa70fc7.jpeg',
    description: 'Dump trailer unloading at the recycling facility'
  },
  {
    id: 6,
    title: 'Full Load Hauling',
    category: 'Residential',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/de198ee85b5e60ae255edcd53a5358ee.jpeg',
    description: 'Team loading up a full trailer in a residential neighborhood'
  },
  {
    id: 7,
    title: 'Room Cleanout',
    category: 'Residential',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/7e405cc856b9ded7c0c90402d5499455.jpeg',
    description: 'Complete room cleanout removing clutter, clothes, and household items'
  },
  {
    id: 8,
    title: 'Garage Junk Removal',
    category: 'Residential',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/6d0d0cf13f261a12a808125bad38a5f9.jpeg',
    description: 'Full garage cleanout with furniture, storage bins, and household clutter'
  },
  {
    id: 9,
    title: 'Storage Facility Cleanout',
    category: 'Commercial',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/7bfa701a50cb6819432bff6aae47be43.jpeg',
    description: 'Large storage unit cleanout with boxes, furniture, and miscellaneous items'
  },
  {
    id: 10,
    title: 'Garage Cleanout',
    category: 'Residential',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/ee4f7c4ed9a4036e66f60497db00ae26.jpeg',
    description: 'Garage space clearing and debris removal ready for a fresh start'
  },
  {
    id: 11,
    title: 'Garage Junk Hauling',
    category: 'Residential',
    image: 'https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/c7c8149b03f700d80fb08fc4be9c4905.jpeg',
    description: 'Full garage cleanout with boxes, baby gear, and household clutter removal'
  }
];

const categories = ['All', 'Residential', 'Commercial'];

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedImage, setSelectedImage] = useState<typeof portfolioItems[0] | null>(null);

  const filteredItems = activeCategory === 'All' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <section id="portfolio" className="relative py-24 bg-gradient-to-b from-black via-gray-900 to-black">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(to right, #D4AF37 1px, transparent 1px), linear-gradient(to bottom, #D4AF37 1px, transparent 1px)',
          backgroundSize: '80px 80px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3D3225] rounded-full mb-6">
            <i className="ri-image-line text-[#D4AF37]"></i>
            <span className="text-[#C4A574] text-sm font-medium tracking-wider">OUR WORK</span>
          </div>
          
          <h3 className="font-['Orbitron'] text-4xl sm:text-5xl font-bold text-white mb-6">
            Project <span className="text-[#D4AF37]">Portfolio</span>
          </h3>
          
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Check out some of the jobs we&apos;ve completed. From garage cleanouts to commercial debris removal, 
            we handle it all with care and professionalism.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-2.5 rounded-full font-medium text-sm transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === category
                  ? 'bg-[#D4AF37] text-black'
                  : 'bg-gray-800/50 text-gray-400 hover:bg-gray-700/50 hover:text-white border border-gray-700'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredItems.map((item) => (
            <div
              key={item.id}
              onClick={() => setSelectedImage(item)}
              className="group relative overflow-hidden rounded-xl border border-gray-800 bg-gray-900/50 cursor-pointer hover:border-[#D4AF37]/50 transition-all duration-300"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <span className="text-[#D4AF37] text-xs font-medium tracking-wider mb-2">{item.category}</span>
                <h4 className="text-white font-semibold text-lg mb-1">{item.title}</h4>
                <p className="text-gray-400 text-sm">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-400 mb-6">Want to see your junk gone? Let&apos;s make it happen!</p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-black font-bold rounded-lg hover:bg-[#E5C158] transition-all hover:shadow-lg hover:shadow-[#D4AF37]/30 cursor-pointer whitespace-nowrap"
          >
            <span>GET YOUR FREE QUOTE</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div 
            className="relative max-w-4xl w-full bg-gray-900 rounded-2xl overflow-hidden border border-gray-800"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-black/50 rounded-full text-white hover:bg-[#D4AF37] hover:text-black transition-all cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
            
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="w-full aspect-video object-cover object-center"
            />
            
            <div className="p-6">
              <span className="text-[#D4AF37] text-sm font-medium tracking-wider">{selectedImage.category}</span>
              <h4 className="text-white font-['Orbitron'] text-2xl font-bold mt-2 mb-2">{selectedImage.title}</h4>
              <p className="text-gray-400">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
